<script lang="ts" setup>
import { brand, theme as brandTheme } from '@/config/brands'

defineProps<{
  config: any
  history: any[]
  fetching: boolean
  ending: boolean
  page: number
  setInfiniteRef: (el: HTMLElement | null) => void
  gotoChapter: (item: any) => void
}>()

const pageBgColor = brandTheme.bgGlobal || '#14181F'
</script>

<template>
  <div :ref="setInfiniteRef" class="pb-20 h-100dvh overflow-scroll" :style="{ background: pageBgColor }">
    <div v-if="history.length === 0 && !fetching" class="mt-11 pt-15vh w-full text-center flex flex-col justify-center">
      <div>
        <img class="mx-a w-100px" src="@/assets/cover-empty.png" alt="empty">
        <p class="mt-14px text-13px text-n-text-2">
          {{ config.texts.noData }}
        </p>
        <div class="mt-50px">
          <router-link
            :to="{ name: 'home' }"
            replace
            class="inline-block text-n-primary text-14px py-2 px-4 border border-solid border-n-primary rounded-full"
          >
            {{ config.texts.goToNovel }}
          </router-link>
        </div>
      </div>
    </div>

    <div v-else class="rr-page-body px-4 pb-4">
      <!-- Initial loading -->
      <div v-if="fetching && page === 1" class="py-120px flex items-center justify-center text-13px text-n-text-3">
        <div class="animate-spin mr-2">
          <i-icon-park-outline-loading />
        </div>
        <p>{{ config.texts.loading }}</p>
      </div>
      <div v-for="item in history" :key="item.contentId" class="rr-history-item" :class="{ 'rr-history-item--bordered': brand === 'flipnovel' }" @click="gotoChapter(item)">
        <div class="relative">
          <img class="w-76px h-102px rounded-10px" :src="item.contentCoverUrl">
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-15px font-bold line-clamp-1 text-n-text-1">
            {{ item.contentName }}
          </p>
          <p class="text-12px mt-6px text-n-text-3">
            <span>{{ item.finishStatus ? config.texts.completed : config.texts.ongoing }}</span>
          </p>
          <p class="text-12px mt-8px text-n-text-3 line-clamp-2">
            {{ config.texts.lastRead }}: {{ item.contentChapterName }}
          </p>
        </div>
      </div>

      <div v-if="ending" class="py-10 flex space-x-2.5 items-center justify-center">
        <span class="text-14px text-n-text-3">{{ config.texts.noMore }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.rr-page-body {
  padding-top: 2px;
}

.rr-history-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
  padding: 0;
  border-radius: 14px;
  border: none;
  background: rgba(255, 255, 255, 0.02);
}

.rr-history-item--bordered {
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.06);
}
</style>
